import Vue from "vue";
import Router from "vue-router";
import store from "./store/store";
import axios from "axios";

import Calendar from "./views/Calendar.vue";
import Settings from "./views/Settings.vue";
import Invite from "./views/Invite.vue";
import WorldLogin from "../../../world/spa/components/WorldLogin.vue";
import TicketsView from "./views/TicketsView.vue";
import TicketsTypesView from "./views/TicketsTypesView.vue";
import TicketsTypeView from "./views/TicketsTypeView.vue";
import TicketsAnalyticsView from "./views/TicketsAnalyticsView.vue";

Vue.use(Router);

// Utilizzato per gestire lo scrolling in caso di navigazione back/forward
const scrollBehavior = (to, from, savedPosition) => {
  let position = {};
  if (savedPosition) {
    return savedPosition;
  } else {
    position.x = 0;
    position.y = 0;
    return position;
  }
};

const router = new Router({
  mode: "history",
  base: process.env.VUE_APP_FRONT_BASE_URL,
  scrollBehavior,
  routes: [
    {
      name: "index",
      path: "/",
      component: Calendar,
      // metadati per poter cambiare il titolo della pagina in fase di navigazione mediante router
      meta: {
        title: "ANM22 Calendar",
        backHref: "",
        section: "calendar",
      },
    },
    {
      path: "/event/:id",
      component: Calendar,
      meta: {
        title: "",
        backHref: "",
        section: "calendar",
      },
    },
    {
      path: "/invited/:id",
      beforeEnter(to, from, next) {
        let slugs = to.params.id;
        let slug = slugs.split(",");
        if (slug.length <= 1) {
          next("/login");
        } else {
          next();
        }
      },
      component: Invite,
      meta: {
        skipLogin: true,
        title: "",
        backHref: "",
        section: "calendar",
      },
    },
    {
      name: "settings",
      path: "/settings",
      component: Settings,
      meta: {
        title: "Settings",
        backHref: "",
        section: "calendar",
      },
    },
    {
      name: "tickets",
      path: "/tickets",
      component: TicketsView,
      meta: {
        title: "Tickets",
        backHref: "",
        section: "tickets",
      },
    },
    {
      name: "ticket-types",
      path: "/tickets/types",
      component: TicketsTypesView,
      meta: {
        title: "Tickets",
        backHref: "/tickets",
        section: "tickets",
      },
    },
    {
      name: "ticket-type",
      path: "/tickets/types/:id",
      component: TicketsTypeView,
      meta: {
        title: "Tickets",
        backHref: "/tickets/types",
        section: "tickets",
      },
    },
    {
      name: "ticket-analytics",
      path: "/tickets/analytics",
      component: TicketsAnalyticsView,
      meta: {
        title: "Tickets",
        backHref: "/tickets",
        section: "tickets",
      },
    },
    {
      name: "login",
      path: "/login",
      component: WorldLogin,
      meta: {
        title: "Login",
        backHref: "",
        section: "login",
      },
    },
    {
      name: "logout",
      path: "/logout",
      beforeEnter(to, from, next) {
        axios
          .post(
            "auth/logout",
            {},
            {
              baseURL:
                process.env.VUE_APP_BACK_DOMAIN +
                process.env.VUE_APP_BACK_BASE_URL +
                "spa/controller/",
              withCredentials: true,
            }
          )
          .then((response) => {
            store.dispatch("auth/logout");
            next("/login");
          })
          .catch((error) => console.log(error));
      },
    },
    {
      name: "clean",
      path: "/clean",
      redirect(to) {
        router.app.$vlfClearDb();
        return "/";
      },
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});

router.beforeEach((to, from, next) => {
  router.app.$Progress.start();
  if (to.meta.skipLogin) {
    if (store.state.auth.checkingLogin) {
      store.dispatch("auth/endLoginCheck");
    }
    next();
  } else {
    //Controllo se è stato effettuato il login, uso Axios perchè non posso accedere ancora al plugin
    if (store.state.auth.checkingLogin) {
      axios
        .get("auth/", {
          baseURL:
            process.env.VUE_APP_BACK_DOMAIN +
            process.env.VUE_APP_BACK_BASE_URL +
            "spa/controller/",
          withCredentials: true,
        })
        .then((response) => {
          if (!response.data.error && response.data.user) {
            //Salvataggio dei dati dell'utente all'interno dello stato
            Promise.all([
              router.app.$vlf("auth").clear(),
              router.app.$vlf("auth").setItem("user", response.data.user),
              store.dispatch("licenses/update", {
                vlf: router.app.$vlf("licenses"),
                objs: response.data.licenses,
              }),
            ])
              .then((result) => {
                store.dispatch("auth/updateUserInfo", {
                  data: response.data.user,
                  app: router.app,
                });
              })
              .catch((error) => {
                console.log(error);
              })
              .finally(() => {
                store.dispatch("auth/endLoginCheck");
                if (to.fullPath === "/login") {
                  next("/");
                } else {
                  next();
                }
              });
          } else {
            store.dispatch("auth/endLoginCheck");
            if (to.path === "/login") {
              next();
            } else {
              next("/login?cb=" + to.path);
            }
          }
        })
        .catch((error) => {
          console.log(error);
          if (!error.status) {
            // Offline -> check local storage
            router.app
              .$vlf("auth")
              .getItem("user")
              .then((result) => {
                return Promise.all([
                  store.dispatch("auth/updateUserInfo", {
                    data: result,
                    app: router.app,
                  }),
                  store.dispatch("licenses/load", router.app.$vlf("licenses")),
                ]);
              })
              .then(() => {
                next();
              })
              .catch((error) => {
                console.log(error);
              });
          }
        });
    } else {
      next();
    }
  }
});

//Nel caso di informazioni statiche, vengono settate qui, altrimenti nei singoli componenti avvengono ulteriori
//elaborazioni
router.afterEach((to, from, next) => {
  document.title = to.meta.title;
  // Modifica l'etichetta dell'headbar
  if (to.path !== "/") {
    store.dispatch("headbar/setHeadbarTitle", to.meta.title);
  } else {
    store.dispatch("headbar/setHeadbarTitle", "");
  }
  // Controllo e setto l'eventuale back href
  store.dispatch("headbar/setBackHref", to.meta.backHref);
  // Setto la voce del menu di navigazione da selezionare
  store.dispatch("menu/setSelected", to.meta.section);
});

export default router;
